import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const ActiveListingsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./ActiveListingsPage')).ActiveListingsPage,
  }))
);

export const ListingPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./ListingPage')).ListingPage,
  }))
);

export const ListingsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./ListingsPage')).ListingsPage,
  }))
);

export const PastListingsPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./PastListingsPage')).PastListingsPage,
  }))
);

export const SharedListingPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./SharedListingPage')).SharedListingPage,
  }))
);
